import React from 'react';
import { SimTypography } from 'components/SimTypography';
import { Box, Grid, Button, Card } from '@mui/material';
import { SimButton } from 'components/SimButton';
import { useTheme } from '@mui/material/styles';

const mock = [
	{
		title: 'Screening',
		subtitle: 'Assessments to screen delays in child development for functional behavior, skill deficit & autism.',
		CTAlink: 'https://www.autismspeaks.org/applied-behavior-analysis',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
				/>
			</svg>
		)
	},
	{
		title: 'Parental Enablement',
		subtitle: 'includes training & support to caregivers to drive consistency at home and during therapy sessions',
		CTAlink: 'https://www.autismspeaks.org/applied-behavior-analysis',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z'
				/>
			</svg>
		)
	},
	{
		title: 'Applied Behavior Analysis (ABA)',
		subtitle:
			'is a scientific therapy to improve attention, focus, memory, communication and reduce harmful behaviors that affect learning',
		CTAlink: 'https://www.autismspeaks.org/applied-behavior-analysis',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z'
				/>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M15 13a3 3 0 11-6 0 3 3 0 016 0z'
				/>
			</svg>
		)
	},
	{
		title: 'Feeding Therapy',
		subtitle:
			'teaches children and parents how to not only eat and eat better but also eating an enjoyable experience',
		CTAlink: 'https://www.autismspeaks.org/applied-behavior-analysis',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122'
				/>
			</svg>
		)
	},
	{
		title: 'Speech Therapy',
		subtitle: 'helps develop skills like comprehension, clarity, voice, fluency, and sound production',
		CTAlink: 'https://www.autismspeaks.org/applied-behavior-analysis',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
				/>
			</svg>
		)
	},
	{
		title: 'Occupational Therapy',
		subtitle: 'helps (re)gain independence by helping develop physical, sensory, or cognitive skills',
		CTAlink: 'https://www.autismspeaks.org/applied-behavior-analysis',
		icon: (
			<svg
				height={24}
				width={24}
				xmlns='http://www.w3.org/2000/svg'
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z'
				/>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={2}
					d='M15 13a3 3 0 11-6 0 3 3 0 016 0z'
				/>
			</svg>
		)
	}
];

const FeaturesEssentials = () => {
	const theme = useTheme();

	const RightSide = () => (
		<Grid container spacing={2} marginTop={0}>
			{mock.map((item, index) => (
				<Grid
					item
					xs={12}
					sm={6}
					key={index}
					data-aos='fade-up'
					data-aos-delay={index * 100}
					data-aos-offset={100}
					data-aos-duration={600}>
					<Box
						display={'block'}
						width={1}
						sx={{
							transform: index % 2 === 1 ? { md: 'translateY(80px)' } : 'none'
						}}>
						<Box component={Card} padding={2} borderRadius={2} width={1}>
							<Box
								height={180}
								display={'flex'}
								flexDirection={'column'}
								justifyContent={'space-between'}>
								<Box width={1}>
									<SimTypography
										width={1}
										textAlign={'right'}
										variant={'h6'}
										sx={{ fontWeight: 700 }}>
										{item.title}
									</SimTypography>
								</Box>

								<Box width={1}>
									<SimTypography textAlign={'justify'} color='text.secondary'>
										{item.subtitle}
									</SimTypography>
									<Box sx={{ flexGrow: 1 }} />
									<Box display={'flex'} justifyContent={'flex-end'}>
										<Button
											href={'/resources'}
											endIcon={
												<Box
													component={'svg'}
													xmlns='http://www.w3.org/2000/svg'
													href={'/contact'}
													fill='none'
													viewBox='0 0 24 24'
													stroke='currentColor'
													width={24}
													height={24}>
													<path
														strokeLinecap='round'
														strokeLinejoin='round'
														strokeWidth={2}
														d='M17 8l4 4m0 0l-4 4m4-4H3'
													/>
												</Box>
											}>
											Learn more
										</Button>
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				</Grid>
			))}
		</Grid>
	);

	const LeftSide = () => (
		<Box paddingX={3}>
			<Box marginBottom={2} marginTop={{ lg: 25 }}>
				<SimTypography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
					SimSouls{' '}
					<Box component='span' color={theme.palette.primary.main}>
						ESSENTIALS
					</Box>
				</SimTypography>
				<SimTypography color='text.secondary' variant={'h6'}>
					Every child's journey is unique. No two days are the same. Research recommends{' '}
					<Box component='span' color={theme.palette.primary.main}>
						early detection and intervention{' '}
					</Box>{' '}
					is the best opportunity. Let our seasoned experts join hands in supporting your child's development
					for the best possible outcomes.
				</SimTypography>
			</Box>

			<Box marginTop={4} width={1} display='flex' justifyContent={'right'}>
				<SimButton
					variant={'contained'}
					size={'large'}
					href={'/contact'}
					endIcon={
						<Box
							component={'svg'}
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							stroke={theme.palette.background.default}
							width={24}
							height={24}>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth={2}
								d='M17 8l4 4m0 0l-4 4m4-4H3'
							/>
						</Box>
					}>
					Schedule Appointment
				</SimButton>
			</Box>
		</Box>
	);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} md={5} alignItems={'center'}>
				<LeftSide />
			</Grid>
			<Grid item container alignItems={'center'} xs={12} md={7}>
				<RightSide />
			</Grid>
		</Grid>
	);
};

export { FeaturesEssentials };
